const Colors = {
  ACCENT: {
    main: "#ACC3FF",
    secondary: "#668FF9",
  },
  NEUTRAL: {
    main: "#000",
    secondary: "#663332",
    white: "#fff",
    grey: "#A5A4A8",
    mint: "#447940",
    lightMint: "#DBF8F3",
    green: "#25DB83",
    lightGreen: "#447940",
    darkGreen: "#304858",
    darkBlue: "#304858",
  },
  ICON: {
    main: "#447940",
    secondary: "#663332",
  },
};

export default Colors;
